/* MYYK Cart — teaser «legg til én vare til og få 40 %» + oppsalg i Impacts cart-drawer.
   Erstatter UpCart (app-embeddet er av i settings_data.json).
   Tallene (full/ls/ids) regnes i Liquid (snippets/myyk-cart-perks.liquid) og leses fra
   <script data-mc-config>; temaet re-rendrer draweren ved hver kurvendring, så vi
   re-initierer på cart:change / cart:refresh + MutationObserver. */
(function () {
  'use strict';
  if (window.__myykCart) return;
  window.__myykCart = true;

  var TOWEL_TYPES = ['håndhåndkle', 'dusjhåndkle'];
  var state = { recs: {}, towels: null, products: {}, busy: false };

  function money(cents) {
    var kr = Math.round(cents / 100);
    return kr.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',–';
  }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function readConfig() {
    var tag = document.querySelector('[data-mc-config]');
    if (!tag) return null;
    try {
      var c = JSON.parse(tag.textContent);
      c.ids = (c.ids || []).filter(Boolean).map(Number);
      return c;
    } catch (e) { return null; }
  }
  function after(cents, pct) { return Math.round(cents * (100 - pct) / 100); }

  /* ---------- data ---------- */
  function fetchJson(url) { return fetch(url).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }
  function getProduct(handle) {
    if (state.products[handle]) return Promise.resolve(state.products[handle]);
    return fetchJson('/products/' + handle + '.js').then(function (p) { if (p) state.products[handle] = p; return p; });
  }
  /* Anbefalinger: komplementære (Search & Discovery) først, «related» som fallback. */
  function getRecs(productId) {
    if (state.recs[productId]) return Promise.resolve(state.recs[productId]);
    var base = '/recommendations/products.json?product_id=' + productId + '&limit=8&intent=';
    return fetchJson(base + 'complementary').then(function (d) {
      if (d && d.products && d.products.length) return d.products;
      return fetchJson(base + 'related').then(function (d2) { return (d2 && d2.products) || []; });
    }).then(function (list) {
      var out = list.map(function (p) {
        return { id: p.id, handle: p.handle, title: p.title, type: (p.type || '').toLowerCase(), tags: p.tags || [], price: p.price, image: p.featured_image || '', available: p.available !== false, variants: p.variants || [] };
      });
      state.recs[productId] = out; return out;
    });
  }
  function getTowels(cfg) {
    if (state.towels) return Promise.resolve(state.towels);
    return fetchJson('/collections/' + cfg.towelCollection + '/products.json?limit=50').then(function (d) {
      var ps = ((d && d.products) || []).map(function (p) {
        var v = p.variants.filter(function (x) { return x.available; })[0];
        if (!v) return null;
        return { id: p.id, handle: p.handle, title: p.title, type: (p.product_type || '').toLowerCase(), tags: p.tags || [], price: Math.round(parseFloat(v.price) * 100), image: (p.images && p.images[0] && p.images[0].src) || '', available: true, variantId: v.id, variantCount: p.variants.length, towel: true };
      }).filter(Boolean).sort(function (a, b) { return a.price - b.price; });
      state.towels = ps; return ps;
    });
  }
  /* Teller mot «2 eller flere» OG får 40 %: sengetøy med tag kampanje-40, eller enkelthåndkle. */
  function unlocks(p) {
    if (TOWEL_TYPES.indexOf(p.type) >= 0) return true;
    return p.tags.indexOf('kampanje-40') >= 0;
  }

  /* ---------- teaser ---------- */
  function renderNudge(root, cfg) {
    var mount = root.querySelector('[data-mc-progress]');
    if (!mount) return;
    var have = cfg.full + cfg.ls, need = Math.max(0, cfg.min - have), pct = cfg.pct;
    /* Rolig og presis (Jonas 2026-10-15): korte tekster, 40 % gjelder bare varer til ordinær pris.
       Tilbudsvarer teller som én av to → linjen står på halvveis til en ordinær vare er lagt til.
       Når 40 % er nådd: ingen linje, bare hva kunden får. */
    var cls = 'mc-nudge', msg, fill = Math.min(100, Math.round(have / cfg.min * 100)), bar = true;
    if (cfg.full === 0 && cfg.ls > 0) {
      fill = 50;
      msg = 'Få <b>' + pct + ' %</b> på neste vare til ordinær pris';
    } else if (cfg.full === 1 && cfg.ls === 0) {
      msg = 'Legg til én vare til og få <b>' + pct + ' %</b>';
    } else if (need > 0) {
      msg = 'Legg til ' + need + ' varer og få <b>' + pct + ' %</b>';
    } else {
      cls += ' is-done'; bar = false;
      msg = '<span class="mc-nudge__ok" aria-hidden="true">✓</span> Du får <b>' + pct + ' %</b> på varer til ordinær pris';
    }
    mount.innerHTML = '<div class="' + cls + '"><p class="mc-nudge__msg">' + msg + '</p>' +
      (bar ? '<div class="mc-bar"><span class="mc-bar__fill" style="width:' + fill + '%"></span></div>' : '') + '</div>';
  }

  /* ---------- oppsalg ---------- */
  function colorName(title) { var m = title.match(/\)\s*(.+)$/); return m ? m[1].trim() : title; }
  function thumb(url, w) { return url ? url + (url.indexOf('?') > 0 ? '&' : '?') + 'width=' + w : ''; }

  /* Enkelthåndklær gruppert per type, én farge = ett produkt (MYYK: farge er produkt). */
  function towelGroups(cfg) {
    return getTowels(cfg).then(function (all) {
      var ok = all.filter(function (t) { return !/-\d+$|kit-opprettet/.test(t.handle); });
      var groups = [];
      ['håndhåndkle', 'dusjhåndkle'].forEach(function (type) {
        var items = ok.filter(function (t) { return t.type === type; });
        if (!items.length) return;
        groups.push({ type: type, label: items[0].title.replace(/\s*\(.*$/, ''), items: items });
      });
      return groups;
    });
  }
  function towelCardHtml(g, cfg, idx) {
    var sel = g.items[0];
    return '<div class="mc-card mc-card--towel" data-tw-group="' + idx + '" data-handle="' + esc(sel.handle) + '" data-vid="' + sel.variantId + '">' +
      '<a class="mc-card__imgwrap" data-tw-link href="/products/' + esc(sel.handle) + '"><img class="mc-card__img" data-tw-img src="' + esc(thumb(sel.image, 160)) + '" alt="" width="60" height="60"></a>' +
      '<div class="mc-card__mid"><a class="mc-card__title" data-tw-title href="/products/' + esc(sel.handle) + '">' + esc(g.label) + ' (2 stk)</a>' +
      '<p class="mc-card__price"><b data-tw-price>' + money(after(sel.price, cfg.pct)) + '</b><s data-tw-was>' + money(sel.price) + '</s></p>' +
      '<p class="mc-card__color">Farge: <b data-tw-color>' + esc(colorName(sel.title)) + '</b></p></div>' +
      '<button type="button" class="mc-card__add" data-tw-add>Legg til</button>' +
      '<div class="mc-dots mc-dots--row">' + g.items.map(function (t, i) {
        return '<button type="button" class="mc-dot' + (i === 0 ? ' is-on' : '') + '" data-tw-pick="' + i + '" aria-label="' + esc(colorName(t.title)) + '" title="' + esc(colorName(t.title)) + '"><img src="' + esc(thumb(t.image, 56)) + '" alt=""></button>';
      }).join('') + '</div></div>';
  }
  function bindTowelCard(card, g, cfg) {
    var sel = g.items[0];
    card.querySelectorAll('[data-tw-pick]').forEach(function (dot) {
      dot.addEventListener('click', function () {
        sel = g.items[Number(dot.dataset.twPick)];
        card.querySelectorAll('.mc-dot').forEach(function (d) { d.classList.remove('is-on'); });
        dot.classList.add('is-on');
        card.querySelector('[data-tw-img]').src = thumb(sel.image, 160);
        card.querySelectorAll('[data-tw-link],[data-tw-title]').forEach(function (a) { a.href = '/products/' + sel.handle; });
        card.querySelector('[data-tw-color]').textContent = colorName(sel.title);
        card.querySelector('[data-tw-price]').textContent = money(after(sel.price, cfg.pct));
        card.querySelector('[data-tw-was]').textContent = money(sel.price);
        var btn = card.querySelector('[data-tw-add]'); btn.disabled = false; btn.textContent = 'Legg til';
      });
    });
    var btn = card.querySelector('[data-tw-add]');
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      addWithButton(btn, sel.variantId).catch(function () {});
    });
  }
  function matchList(cfg) {
    var seeds = cfg.ids.slice(0, 2);
    return Promise.all(seeds.map(getRecs)).then(function (lists) {
      var seen = {}, out = [];
      [].concat.apply([], lists).forEach(function (p) {
        if (!p.available || seen[p.id] || cfg.ids.indexOf(p.id) >= 0 || !unlocks(p)) return;
        if (TOWEL_TYPES.indexOf(p.type) >= 0) return;
        seen[p.id] = 1; out.push(p);
      });
      return out.slice(0, cfg.recLimit);
    });
  }
  function getLagersalg() {
    if (state.lagersalg) return Promise.resolve(state.lagersalg);
    return fetchJson('/collections/arkiv/products.json?limit=6').then(function (d) {
      var ps = ((d && d.products) || []).filter(function (p) { return p.variants.some(function (v) { return v.available; }); })
        .map(function (p) { return { image: (p.images && p.images[0] && p.images[0].src) || '', price: Math.min.apply(null, p.variants.filter(function (v) { return v.available; }).map(function (v) { return Math.round(parseFloat(v.price) * 100); })) }; });
      state.lagersalg = ps; return ps;
    });
  }
  var CHEV = '<svg class="mc-card__chev" viewBox="0 0 10 10" width="10" height="10" aria-hidden="true"><path d="M2 3.5l3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function cardHtml(p, cfg) {
    var multi = p.variants && p.variants.length > 1;
    return '<div class="mc-card" data-mc-card data-handle="' + esc(p.handle) + '" data-pid="' + p.id + '">' +
      '<a class="mc-card__imgwrap" href="/products/' + esc(p.handle) + '"><img class="mc-card__img" src="' + esc(thumb(p.image, 160)) + '" alt="" loading="lazy" width="60" height="60"></a>' +
      '<div class="mc-card__mid"><a class="mc-card__title" href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a>' +
      '<p class="mc-card__price"><b>' + money(after(p.price, cfg.pct)) + '</b><s>' + money(p.price) + '</s></p></div>' +
      '<button type="button" class="mc-card__add" data-mc-add aria-label="' + (multi ? 'Velg størrelse, ' : 'Legg til ') + esc(p.title) + '"' + (multi ? ' aria-expanded="false"' : '') + '>' + (multi ? 'Velg størrelse' + CHEV : 'Legg til') + '</button>' +
      '<div class="mc-card__variants" data-mc-variants hidden></div></div>';
  }
  function renderUpsell(root, cfg) {
    var mount = root.querySelector('[data-mc-upsell]');
    if (!mount) return;
    var seq = state.seq = (state.seq || 0) + 1; /* bare siste render får skrive (raske kurvendringer) */
    if (!mount.firstChild) mount.innerHTML = '<p class="mc-loading">Finner noe som passer…</p>';
    var bareOrdinaere = cfg.ls === 0 && cfg.full >= 1;
    Promise.all([bareOrdinaere ? getLagersalg() : Promise.resolve([]), towelGroups(cfg), matchList(cfg)]).then(function (r) {
      if (seq !== state.seq) return;
      var ls = r[0], groups = r[1], matches = r[2], html = '';
      if (ls.length) {
        var from = Math.min.apply(null, ls.map(function (p) { return p.price; }));
        html += '<a class="mc-strip" href="/collections/arkiv"><span class="mc-strip__imgs">' + ls.slice(0, 3).map(function (p) { return '<img src="' + esc(thumb(p.image, 80)) + '" alt="">'; }).join('') + '</span>' +
          '<span class="mc-strip__tx"><b>Arkiv: krepp</b> fra ' + money(from) + '</span><span class="mc-strip__go">Se alle ›</span></a>';
      }
      if (matches.length) html += '<p class="mc-group__title">Kjøpes ofte med</p>' + matches.map(function (p) { return cardHtml(p, cfg); }).join('');
      if (groups.length) html += '<p class="mc-group__title">Håndklær</p>' + groups.map(function (g, i) { return towelCardHtml(g, cfg, i); }).join('');
      mount.innerHTML = html;
      mount.querySelectorAll('[data-tw-group]').forEach(function (card) { bindTowelCard(card, groups[Number(card.dataset.twGroup)], cfg); });
      mount.querySelectorAll('[data-mc-card]').forEach(bindCard);
      /* Forhåndshent størrelser + forhåndsbestillingsstatus, så «Velg størrelse» åpner uten venting. */
      setTimeout(function () { matches.forEach(function (p) { getProduct(p.handle); getStatus(p.handle); }); }, 300);
    });
  }

  /* ---------- legg i kurv ---------- */
  /* Forhåndsbestilling: status per variant fra templates/product.fb-status.liquid (samme regel som PDP). */
  function getStatus(handle) {
    state.fb = state.fb || {};
    if (state.fb[handle]) return Promise.resolve(state.fb[handle]);
    return fetchJson('/products/' + handle + '?view=fb-status').then(function (s) { s = s || { v: {} }; state.fb[handle] = s; return s; });
  }
  function addVariant(variantId, fb) {
    if (state.busy) return Promise.reject(new Error('busy'));
    state.busy = true;
    var item = { id: variantId, quantity: 1 };
    if (fb && fb.v[variantId] === 'pre') item.properties = { 'Forhåndsbestilt': 'Sendes ca. ' + fb.dato };
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(item) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); })
      .finally(function () { state.busy = false; });
  }
  /* Felles knappeflyt for «Legg til»: «…» → «Lagt til», eller tilbake med «Prøv igjen» ved feil. */
  function addWithButton(btn, variantId, fb) {
    if (state.busy) return Promise.reject(new Error('busy'));
    btn.style.minWidth = btn.offsetWidth + 'px'; /* ingen breddehopp ved «…» / «Lagt til» */
    btn.disabled = true; btn.textContent = '…';
    return addVariant(variantId, fb).then(function () { btn.textContent = 'Lagt til'; }, function (e) {
      btn.disabled = false; btn.textContent = 'Prøv igjen'; throw e;
    });
  }
  function bindCard(card) {
    var btn = card.querySelector('[data-mc-add]');
    var box = card.querySelector('[data-mc-variants]');
    /* Disclosure-knapp: fast tekst, pila + aria-expanded viser om størrelsene er åpne. */
    function setOpen(open) {
      box.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      if (!box.hidden) { setOpen(false); return; }
      btn.disabled = true; btn.setAttribute('aria-busy', 'true'); /* vanligvis forhåndshentet — da merkes dette ikke */
      Promise.all([getProduct(card.dataset.handle), getStatus(card.dataset.handle)]).then(function (res) {
        var p = res[0], fb = res[1];
        btn.disabled = false; btn.removeAttribute('aria-busy');
        if (!p) { btn.textContent = 'Prøv igjen'; return; }
        var avail = p.variants.filter(function (v) { return v.available; });
        if (!avail.length) { btn.textContent = 'Utsolgt'; btn.disabled = true; return; }
        if (p.variants.length === 1) { addWithButton(btn, avail[0].id, fb).catch(function () {}); return; }
        if (!box.firstChild) {
          /* K2: like brede chips over hele kortet, prikk = forhåndsbestilling, én forklaring under. */
          var anyPre = false;
          box.innerHTML = avail.map(function (v) {
            var pre = fb.v[v.id] === 'pre'; if (pre) anyPre = true;
            var size = esc(v.title).replace(/(\d)x(\d)/g, '$1×$2');
            return '<button type="button" class="mc-chip" data-vid="' + v.id + '"><span>' + size + '</span>' + (pre ? '<i class="mc-chip__dot" aria-label="Forhåndsbestilling"></i>' : '') + '</button>';
          }).join('') + (anyPre ? '<p class="mc-fb-legend"><i class="mc-chip__dot"></i>Forhåndsbestilling</p>' : '');
          box.querySelectorAll('.mc-chip').forEach(function (chip) {
            chip.addEventListener('click', function () {
              if (state.busy) return;
              box.querySelectorAll('.mc-chip').forEach(function (c) { c.classList.remove('is-active'); });
              chip.classList.add('is-active');
              addWithButton(btn, Number(chip.dataset.vid), fb).catch(function () { chip.classList.remove('is-active'); });
            });
          });
        }
        setOpen(true);
      });
    });
  }

  /* ---------- fjern / antall: robust mot utdaterte linjenøkler ----------
     BXGY-rabatten splitter og slår sammen lagersalgslinjer, så line_item.key kan
     bytte etter en kurvendring. Impacts handler sender nøkkelen rått og viser
     «ingen gyldig id eller linjeparameter» hvis den er borte. Vi sjekker nøkkelen
     mot fersk /cart.js først; finnes den ikke, tegnes draweren på nytt. */
  function refresh() { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); }
  function lineChange(lineEl, key, qty) {
    if (!key || isNaN(qty)) { refresh(); return; }
    lineEl && lineEl.dispatchEvent(new CustomEvent('line-item:will-change', { bubbles: true, detail: { targetQuantity: qty } }));
    fetchJson('/cart.js').then(function (cart) {
      if (!cart || !cart.items.some(function (i) { return i.key === key; })) { refresh(); return; }
      var sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty, sections: sections }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, cart: j }; }); })
        .then(function (res) {
          if (!res.ok) { refresh(); return; }
          var after = res.cart.items.filter(function (i) { return i.key === key; });
          lineEl && lineEl.dispatchEvent(new CustomEvent('line-item:change', { bubbles: true, detail: { quantity: after.length ? after[0].quantity : 0, cart: res.cart } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'line-item:change', cart: res.cart } }));
        });
    }).catch(refresh);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('#cart-drawer a[href*="/cart/change"]');
    if (!a) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var u = new URL(a.href, location.origin);
    lineChange(a.closest('line-item'), u.searchParams.get('id'), parseInt(u.searchParams.get('quantity'), 10));
  }, true);
  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp.matches || !inp.matches('#cart-drawer input[data-line-key]')) return;
    e.stopImmediatePropagation();
    lineChange(inp.closest('line-item'), inp.getAttribute('data-line-key'), parseInt(inp.value, 10));
  }, true);

  /* ---------- rabattkode (Ajax: /cart/update.js { discount }) ---------- */
  function applyCodes(codes, sectionsAware) {
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: codes.join(','), sections: sections }) })
      .then(function (r) { return r.json(); });
  }
  function currentCodes() {
    return fetchJson('/cart.js').then(function (c) { return ((c && c.discount_codes) || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; }); });
  }
  function rerender(cart) { document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'discount-code:change', cart: cart } })); }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('#cart-drawer [data-mc-code]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input'), msg = form.querySelector('[data-mc-code-msg]'), btn = form.querySelector('button');
    var code = (input.value || '').trim().toUpperCase();
    if (!code) return;
    btn.disabled = true; msg.hidden = true;
    currentCodes().then(function (codes) {
      if (codes.indexOf(code) >= 0) return { cart: null, dup: true };
      return applyCodes(codes.concat(code)).then(function (cart) {
        var hit = (cart.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === code; })[0];
        if (!hit || !hit.applicable) {
          return applyCodes(codes).then(function () { return { cart: null, invalid: true }; });
        }
        return { cart: cart };
      });
    }).then(function (res) {
      btn.disabled = false;
      if (res.invalid) { msg.textContent = 'Koden gjelder ikke for denne kurven.'; msg.hidden = false; input.select(); return; }
      if (res.dup) { msg.textContent = 'Koden er allerede lagt til.'; msg.hidden = false; return; }
      input.value = ''; rerender(res.cart);
    }).catch(function () { btn.disabled = false; msg.textContent = 'Noe gikk galt. Prøv igjen.'; msg.hidden = false; });
  });
  document.addEventListener('click', function (e) {
    var x = e.target.closest && e.target.closest('#cart-drawer [data-mc-code-remove]');
    if (!x) return;
    e.preventDefault();
    var code = x.getAttribute('data-mc-code-remove').toUpperCase();
    currentCodes().then(function (codes) { return applyCodes(codes.filter(function (c) { return c.toUpperCase() !== code; })); })
      .then(rerender).catch(refresh);
  });

  /* ---------- antall-stepper (− / +) rundt Impacts quantity-input ---------- */
  var stepTimers = {};
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#cart-drawer [data-mc-step]');
    if (!b) return;
    e.preventDefault();
    var inp = b.parentElement.querySelector('input[data-line-key]');
    if (!inp) return;
    var v = parseInt(inp.value, 10) || 0, step = Number(b.getAttribute('data-mc-step')), min = parseInt(inp.min, 10) || 1;
    var next = v + step, key = inp.getAttribute('data-line-key');
    clearTimeout(stepTimers[key]);
    if (next < min) { lineChange(inp.closest('line-item'), key, 0); return; } /* minus på 1 = fjern varen */
    inp.value = next; /* vis nytt antall med en gang … */
    stepTimers[key] = setTimeout(function () { /* … men send én forespørsel når kunden har trykket ferdig */
      delete stepTimers[key];
      lineChange(inp.closest('line-item'), key, parseInt(inp.value, 10));
    }, 350);
  }, true);

  /* ---------- init ---------- */
  var timer = null;
  function render() {
    var root = document.getElementById('cart-drawer');
    var cfg = root && readConfig();
    if (!cfg) return;
    renderNudge(root, cfg);
    renderUpsell(root, cfg);
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(render, 120); }
  ['cart:change', 'cart:refresh'].forEach(function (ev) {
    document.addEventListener(ev, schedule);
    document.documentElement.addEventListener(ev, schedule);
  });
  var mo = new MutationObserver(function () {
    if (document.querySelector('#cart-drawer [data-mc-progress]:empty')) schedule();
  });
  function arm() { var d = document.getElementById('cart-drawer'); if (d) mo.observe(d, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { arm(); schedule(); });
  else { arm(); schedule(); }
})();
